import { MediaFileStatus } from "@next-platform/packages-ts-types";
export default function getMediaFilePlaceholder({ file, translate }) {
    switch (file?.status) {
        case MediaFileStatus.AVAILABLE:
        case MediaFileStatus.EXPIRING:
            return null;
        case MediaFileStatus.DELETED:
            return {
                kind: "deleted",
                title: translate("mediaFile:unavailable.deleted.title", { defaultValue: "This image has been deleted" }),
                description: translate("mediaFile:unavailable.deleted.description", {
                    defaultValue: "It’s no longer stored and can’t be viewed again.",
                }),
            };
        case MediaFileStatus.EXPIRED:
            return {
                kind: "expired",
                title: translate("mediaFile:unavailable.expired.title", { defaultValue: "This image has expired" }),
                description: translate("mediaFile:unavailable.expired.description", {
                    defaultValue: "It wasn’t kept, so it was removed after its storage period ended. Keep images you want to hold on to.",
                }),
            };
        case MediaFileStatus.BANNED: {
            // Owner-only: a non-owner's record carries no reason, and falls through to the generic copy.
            const reasons = "reason_for_moderation" in file ? file.reason_for_moderation : undefined;
            const moderationReasons = reasons?.map((reason) => reason.trim()).filter(Boolean) ?? [];
            return {
                kind: "banned",
                title: translate("mediaFile:unavailable.banned.title", { defaultValue: "This image has been removed" }),
                description: moderationReasons.length
                    ? moderationReasons.join("\n")
                    : translate("mediaFile:unavailable.banned.description", {
                        defaultValue: "It was removed after moderation and can no longer be viewed.",
                    }),
            };
        }
        default:
            return {
                kind: "notFound",
                title: translate("mediaFile:unavailable.notFound.title", { defaultValue: "This image is unavailable" }),
                description: translate("mediaFile:unavailable.notFound.description", {
                    defaultValue: "It may have been removed, or you may not have access to it.",
                }),
            };
    }
}
